import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminProducts() {

  
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [maincatname, setMaincatname] = useState([]);
  const [subcatname, setSubcatname] = useState([]);
  const [year, setYear] = useState([]);
  const [language, setLanguage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
    const [booksPerPage, setBooksPerPage] = useState(10); // Default rows per page
    const [selectedPublisher, setSelectedPublisher] = useState('');
    const [selectedMaincatname, setSeletedMaincatname] = useState('');
    const [selectedSubcatname, setSelectedSubcatname] = useState('');
    const [selectedYear, setSeletedYear] = useState('');
    const [selectedLanguage, setSeletedLanguage] = useState('');
    const [selectedCategory, setSelectedCategory] = useState("");
    const personName =localStorage.getItem("loginsetName");
    const handleFormSubmit = async (e) => {
      e.preventDefault();

      const formData = new FormData(e.target);
    if (!formData.get('booktitle') || !formData.get('description') || !imageFile || !formData.get('originalprice') || !formData.get('descprice') || !formData.get('publisher') || !formData.get('language') || !formData.get('maincatname') || !formData.get('subcatname') || !formData.get('searchcategory')) {
  alert('Please fill all required fields.');
  return;
}

      if (imageFile) {
        formData.append('image', imageFile); // ✅ already in use

      }
      if (personName) {
        formData.append('person', personName); // ✅ already in use

      }

    
      try {
        const url = editingBook ? `${apiUrl}/public/updateBookById` : `${apiUrl}/public/savebook`;
        const method = editingBook ? 'PUT' : 'POST';
    
        if (editingBook) {
          formData.append('id', editingBook.id); // Include the book ID for updating
        }
    
        const response = await fetch(url, {
          method: method,
          body: formData,
        });
    
        if (response.ok) {
          alert(editingBook ? 'Product updated successfully!' : 'Product added successfully!');
          e.target.reset();
          setImageFile(null);
          setEditingBook(null); // Reset editing state
          AllBooks(); // Refresh the book list
        } else {
          const errorData = await response.json();
          alert(`Error: ${errorData.message}`);
        }
      } catch (error) {
        console.error('Error adding/updating product:', error);
        alert('Check All required Fields Then Please try again later.');
      }
    };
  useEffect(() => {
    const fetchBooks = async () => {
      try {
        let url = `${apiUrl}/public/allbooks`;
  
        const params = new URLSearchParams();
        if (selectedPublisher) params.append('publisher', selectedPublisher);
        if (selectedMaincatname) params.append('maincatname', selectedMaincatname);
        if (selectedYear) params.append('year', selectedYear);
        if (selectedSubcatname) params.append('subcatname', selectedSubcatname);
        if (selectedLanguage) params.append('language', selectedLanguage);
  
        if (params.toString()) {
          url += `?${params.toString()}`;
        }
  
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const data = await response.json();
        setBooks(data.reverse());
      } catch (error) {
        console.error('Error fetching books:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchBooks();
  }, [selectedPublisher, selectedMaincatname,selectedYear,selectedLanguage,selectedSubcatname]);
  
  // Handle publisher change from the dropdown
  const handlePublisherChange = (event) => {
    const publisher = event.target.value;
    setSelectedPublisher(publisher);

    // Update the URL with the selected publisher
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('publisher', publisher); // Add the publisher to the URL query
    window.history.pushState({}, '', currentUrl); // Update the browser URL without reloading
  };
  const handleMaincatnameChange = (event) => {
    const maincatname = event.target.value;
    setSeletedMaincatname(maincatname);

    // Update the URL with the selected maincatname
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('maincatname', maincatname); // Add the publisher to the URL query
    window.history.pushState({}, '', currentUrl); // Update the browser URL without reloading
  };
  const handleSubcatnameChange = (event) => {
    const subcatname = event.target.value;
    setSelectedSubcatname(subcatname); // ✅ Corrected here
  
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('subcatname', subcatname);
    window.history.pushState({}, '', currentUrl);
  };
  
  const handleYearChange = (event) => {
    const year = event.target.value;
    setSeletedYear(year);

    // Update the URL with the selected maincatname
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('year', year); // Add the publisher to the URL query
    window.history.pushState({}, '', currentUrl); // Update the browser URL without reloading
  };
  const handleLanguageChange = (event) => {
    const language = event.target.value;
    setSeletedLanguage(language);

    // Update the URL with the selected maincatname
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('language', language); // Add the publisher to the URL query
    window.history.pushState({}, '', currentUrl); // Update the browser URL without reloading
  };

  const AllBooks = () => {
    // Fetching data from the API
    fetch(`${apiUrl}/public/allpublisher`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clean the data: Remove empty, null values and duplicate entries
        const cleanedData = Array.from(new Set(data.filter((publisher) => publisher && publisher.trim() !== '')));

        setPublishers(cleanedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching publishers:', error);
        setLoading(false);
      });
    }
  const AllBooks2 = () => {
    // Fetching data from the API
    fetch(`${apiUrl}/public/allmaincatname`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clean the data: Remove empty, null values and duplicate entries
        const cleanedData2 = Array.from(new Set(data.filter((maincatname) => maincatname && maincatname.trim() !== '')));

        setMaincatname(cleanedData2);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching maincatname:', error);
        setLoading(false);
      });
    }
  const AllBooks5 = () => {
    // Fetching data from the API
    fetch(`${apiUrl}/public/allsubcatnames`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clean the data: Remove empty, null values and duplicate entries
        const cleanedData2 = Array.from(new Set(data.filter((subcatname) => subcatname && subcatname.trim() !== '')));

        setSubcatname(cleanedData2);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching maincatname:', error);
        setLoading(false);
      });
    }
  const AllBooks3 = () => {
    // Fetching data from the API
    fetch(`${apiUrl}/public/allyear`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clean the data: Remove empty, null values and duplicate entries
        const cleanedData3 = Array.from(new Set(data.filter((year) => year && year.trim() !== '')));

        setYear(cleanedData3);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching maincatname:', error);
        setLoading(false);
      });
    }
  const AllBooks4 = () => {
    // Fetching data from the API
    fetch(`${apiUrl}/public/alllanguage`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clean the data: Remove empty, null values and duplicate entries
        const cleanedData4 = Array.from(new Set(data.filter((language) => language && language.trim() !== '')));

        setLanguage(cleanedData4);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching maincatname:', error);
        setLoading(false);
      });
    }
  useEffect(() => {
    AllBooks();
    AllBooks2();
    AllBooks3();
    AllBooks4();
    AllBooks5();
  }, []);



  const handleDelete = (bookId) => {
    
    fetch(`${apiUrl}/public/deleteById?bid=${bookId}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      alert("Deleted Successfully");
      AllBooks();
      return response.json();
    })
    .catch(error => {
      console.error('There was a problem with the delete request:', error);
    });
  };
  
  const [searchTerm, setSearchTerm] = useState("");
  // Filter books based on search term
const filteredBooks = books.filter(book =>
  (book.booktitle && book.booktitle.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.maincatname && book.maincatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.subcatname && book.subcatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.publisher && book.publisher.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.year && book.year.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.language && book.language.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.author && book.author.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.isbn && book.isbn.includes(searchTerm)) ||
  (book.id && book.id.toString().includes(searchTerm)) // Ensure ID is checked as a string

);


  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);


  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  useEffect(() => {
    fetch(`${apiUrl}/public/allCategories`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        return response.json();
      })
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  const handleEdit = (book) => {
    setEditingBook(book); // Set the selected book for editing
    setCategory(book.maincatname); // Set the category to the current book's category
    setSubCategory(book.subcatname); // Set the subcategory to the current book's subcategory
  };
  const handleMainCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);
    setSubCategory("");
    setSubCategories([]); // Clear subcategories when category changes

    fetch(`${apiUrl}/public/getsubCatByCatName?cname=${selectedCategory}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch subcategories");
        }
        return response.json();
      })
      .then((data) => setSubCategories(data))
      .catch((error) => console.error("Error fetching subcategories:", error));
  };



  useEffect(() => {
    // When editingBook changes, update the selected category
    if (editingBook) {
      setSelectedCategory(editingBook.searchcategory);
    }
  }, [editingBook]);
  
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    if (editingBook) {
      setCategory(editingBook.maincatname);
      setSubCategory(editingBook.subcatname);
  
      // Fetch subcategories when editingBook is loaded
      fetch(`${apiUrl}/public/getsubCatByCatName?cname=${editingBook.maincatname}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch subcategories");
          }
          return response.json();
        })
        .then((data) => {
          setSubCategories(data);
        })
        .catch((error) => console.error("Error fetching subcategories:", error));
    }
  }, [editingBook]);
  
  






  return (
<>



    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
            Product Management
          </Text>
        </Flex>

        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Product
          </Text>
          
          <form onSubmit={handleFormSubmit} encType="multipart/form-data">
            <SimpleGrid columns={4} spacing={4}>
              <FormControl id="booktitle" isRequired>
                <FormLabel>Book Title</FormLabel>
                <Input type="hidden" placeholder="Enter book id" name="id" defaultValue={editingBook ? editingBook.id : ''}/>
                <Input type="text" placeholder="Enter book title" name="booktitle" defaultValue={editingBook ? editingBook.booktitle : ''}/>
              </FormControl>
              <FormControl id="author" >
                <FormLabel>Author</FormLabel>
                <Input type="text" placeholder="Enter author name" name="author" defaultValue={editingBook ? editingBook.author : ''}/>
              </FormControl>
              <FormControl id="description" isRequired>
                <FormLabel>Description</FormLabel>
                <Input type="text" placeholder="Enter description" name="description" defaultValue={editingBook ? editingBook.description : ''}/>
              </FormControl>
              <FormControl id="image" isRequired>
                <FormLabel>Upload Image</FormLabel>
                <Input type="file" name="imageFile" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])}   />
              </FormControl>
              <FormControl id="originalprice" isRequired>
                <FormLabel>Original Price</FormLabel>
                <Input type="number" placeholder="Enter original price" name="originalprice" defaultValue={editingBook ? editingBook.originalprice : ''}/>
              </FormControl>
              <FormControl id="descprice" isRequired>
                <FormLabel>Discounted Price</FormLabel>
                <Input type="number" placeholder="Enter discounted price" name="descprice" defaultValue={editingBook ? editingBook.descprice : ''}/>
              </FormControl>
              <FormControl id="format" >
                <FormLabel>Format</FormLabel>
                <Input type="text" placeholder="Enter Format" name="format" defaultValue={editingBook ? editingBook.format : ''}/>
              </FormControl>
              <FormControl id="pages" >
                <FormLabel>Pages</FormLabel>
                <Input type="number" placeholder="Enter Pages" name="pagess" defaultValue={editingBook ? editingBook.pagess : ''}/>
              </FormControl>
              <FormControl id="publisher"isRequired >
                <FormLabel>Publisher Name</FormLabel>
                <Input type="text" placeholder="Enter Publisher Name" name="publisher" defaultValue={editingBook ? editingBook.publisher : ''}/>
              </FormControl>
              <FormControl id="language" isRequired>
                <FormLabel>Book Language</FormLabel>
                <Input type="text" placeholder="Enter Book Language" name="language" defaultValue={editingBook ? editingBook.language : ''}/>
              </FormControl>
              <FormControl id="isbn" >
                <FormLabel>ISBN</FormLabel>
                <Input type="text" placeholder="Enter ISBN" name="isbn" defaultValue={editingBook ? editingBook.isbn : ''}/>
              </FormControl>
              <FormControl id="hsn" >
                <FormLabel>HSN Number</FormLabel>
                <Input type="number" placeholder="Enter HSN" name="hsn" defaultValue={editingBook ? editingBook.hsn : ''}/>
              </FormControl>
              <FormControl id="year" >
                <FormLabel>Publish Year</FormLabel>
                <Input type="text" placeholder="Enter Publish Year" name="year" defaultValue={editingBook ? editingBook.year : ''}/>
              </FormControl>
              <FormControl id="volume" >
                <FormLabel>Book Volume</FormLabel>
                <Input type="text" placeholder="Enter Book Volume" name="volume" defaultValue={editingBook ? editingBook.volume : ''}/>
              </FormControl>
            
              <FormControl id="dimension" >
                <FormLabel>Dimension</FormLabel>
                <Input type="text" placeholder="Enter Dimension" name="dimension" defaultValue={editingBook ? editingBook.dimension : ''}/>
              </FormControl>
              <FormControl id="publishercode" >
                <FormLabel>Publisher Code</FormLabel>
                <Input type="text" placeholder="Enter Publisher Code" name="publishercode" defaultValue={editingBook ? editingBook.publishercode : ''}/>
              </FormControl>
              <FormControl id="maincatname" isRequired>
        <FormLabel>Select Category</FormLabel>
        <select name="maincatname" value={category} onChange={handleMainCategoryChange} required>
          <option>Select Category</option>
          {/* <option value="Books">Books</option>
          <option value="E-Books">E-Books</option>
          <option value="New Release">New Release</option>
          <option value="Academic Books">Academic Books </option>
          <option value="Digest">Digest</option> */}
          {categories.length > 0 ? (
            categories.map((cat) => (
              <option key={cat.catId} value={cat.maincatname}>
                {cat.maincatname}
              </option>
            ))
          ) : (
            <option value="">No categories available</option>
          )}
        </select>
      </FormControl>

      <FormControl id="subcatname" isRequired>
        <FormLabel>Select Sub Category</FormLabel>
        <select name="subcatname" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
          <option value="">Select Sub Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
      <FormControl id="searchcategory" isRequired >
        <FormLabel>Select Search Category</FormLabel>
        <select name="searchcategory" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
          <option value="">Select Search Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
              <FormControl id="jurisdiction" >
                <FormLabel>Add Jurisdiction</FormLabel>
                <Input type="text" placeholder="Enter Jurisdiction" name="jurisdiction" defaultValue={editingBook ? editingBook.jurisdiction : ''}/>
              </FormControl>
         




              <FormControl id="recomandate"  >
        <FormLabel>Recomendate Book</FormLabel>
        <select name="recomandate">
          <option value="0">No</option>
          <option value="1">Yes</option>
         
        </select>
      </FormControl>






     




            </SimpleGrid>
            <VStack mt={4} align="stretch">
              <Button type="submit" colorScheme="teal" width="full" >
                Add Product
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>

    </Flex>

    <Box p={3}>
      <Heading as="h2" size="lg" mb={4}>Books List</Heading>

      <FormControl id="search" >
  <FormLabel>Search Products</FormLabel>
<Input
  type="text"
  placeholder="Search..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  width="800px"
  mb="5"
  bg="white"
  borderColor="gray.300"
  borderRadius="md"
  padding="10px"
  fontSize="md"
  color="gray.600"
  _placeholder={{ color: "gray.400" }}
  _focus={{ borderColor: "teal.500", boxShadow: "md" }}
/>
</FormControl>
<Box>
      {loading ? (
        <Center>
          <Spinner size="lg" />
        </Center>
      ) : (
        <Box>
          {/* Publisher Select Dropdown */}
         <div className='flex gap-8'>
         <Select
            placeholder="Select Publisher"
            value={selectedPublisher}
            onChange={handlePublisherChange}
            width="300px"
            mb={4}
          >
            {publishers.map((publisher, index) => (
              <option key={index} value={publisher}>
                {publisher}
              </option>
            ))}
          </Select>
         <Select
            placeholder="Select Category"
            value={selectedMaincatname}
            onChange={handleMaincatnameChange}
            width="300px"
            mb={4}
          >
            {maincatname.map((maincatname, index) => (
              <option key={index} value={maincatname}>
                {maincatname}
              </option>
            ))}
       
          </Select>
         <Select
            placeholder="Select Sub Category"
            value={selectedSubcatname}
            onChange={handleSubcatnameChange}
            width="300px"
            mb={4}
          >
            {subcatname.map((subcatname, index) => (
              <option key={index} value={subcatname}>
                {subcatname}
              </option>
            ))}
       
          </Select>
         <Select
            placeholder="Select Year"
            value={selectedYear}
            onChange={handleYearChange}
            width="300px"
            mb={4}
          >
            {year.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
       
          </Select>
         <Select
            placeholder="Select Language"
            value={selectedLanguage}
            onChange={handleLanguageChange}
            width="300px"
            mb={4}
          >
            {language.map((language, index) => (
              <option key={index} value={language}>
                {language}
              </option>
            ))}
       
          </Select>







        
          </div> 

          {/* Display Books List */}
          <Box>
            {books.length > 0 ? (
              <ul>
                {books.map((book) => (
                  <li key={book.id}>{book.name}</li>
                ))}
              </ul>
            ) : (
              <p>No books available for this publisher.</p>
            )}
          </Box>
        </Box>
      )}
    </Box>


      {loading ? (
        <Center>
          <Spinner size="sm" />
        </Center>
      ) : (
        <>
          <TableContainer>
          <Flex justify="space-between" mb={4}>

          <Select
          width="150px"
          value={booksPerPage}
          onChange={(e) => {
            setBooksPerPage(Number(e.target.value));
            setCurrentPage(1); // Reset to first page on change
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
        </Select>
        <h1>Total Books : {currentBooks.length}</h1>


        {/* <Flex gap={2}>
          <Button onClick={prevPage} isDisabled={currentPage === 1}>
            Previous
          </Button>
          <Button onClick={nextPage} isDisabled={currentPage === totalPages}>
            Next
          </Button>
        </Flex> */}
      </Flex>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                <Th>Actions</Th>
                <Th>Entry By</Th>
      <Th>ID</Th>
      <Th>Title</Th>
      <Th>Author</Th>
      <Th>Publication Year</Th>
      <Th>Original Price</Th>
      <Th>Discounted Price</Th>
      <Th>Format</Th>
      <Th>Book Pages</Th>
      <Th>Publisher</Th>
      <Th>Language</Th>
      <Th>ISBN</Th>
      <Th>Publisher Code</Th>
      <Th>Created Date</Th>
      <Th>Category</Th>
      <Th>Sub Category</Th>
      <Th>Search Category</Th>
      <Th>Jurisdiction</Th>
      <Th>Volume</Th> {/* Assuming `book.volume` is correct */}
     

          
              
                </Tr>
              </Thead>
              <Tbody>
                {currentBooks.map(book => (
                  <Tr key={book.id}>
                         
                     <Td>
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit Book"
                          icon={<FiEdit />}
                          // onClick={() => handleEdit(book)}
                          onClick={() => {
                            handleEdit(book);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        />
                        <IconButton
                          aria-label="Delete Book"
                          icon={<FiTrash2 />}
                          colorScheme="red"
                          onClick={() => handleDelete(book.id)}
                        />
                      </Flex>
                    </Td> 
                     <Td>{book.person ? book.person:'kstar'}</Td>
                    <Td>{book.id}</Td>
                    <Td>{book.booktitle}</Td>
                    <Td>{book.author}</Td>
                    <Td>{book.year}</Td>
                    <Td>{book.originalprice}</Td>
                    <Td>{book.descprice}</Td>
                    <Td>{book.format}</Td>
                    <Td>{book.pagess}</Td>
                    <Td>{book.publisher}</Td>
                    <Td>{book.language}</Td>
                    <Td>{book.dimension}</Td>
                    <Td>{book.publishercode}</Td>
                    <Td>{book.dateadded}</Td>
                    <Td>{book.maincatname}</Td>
                    <Td>{book.subcatname}</Td>
                    <Td>{book.searchcategory}</Td>
                    <Td>{book.jurisdiction}</Td>
                    <Td>{book.volume}</Td>
              
                
                
                  
                   
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex justify="space-between" mt={4}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </Button>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Flex>
        </>
      )}
    </Box>
</>
    
  );
}

export default AdminProducts;
